import React from "react";
import PropTypes from "prop-types";

const CustomerAction = ({ title, action, icon, isOrderOpened, active, isSpecialCart }) => (
  <button type="button" className={`action ${active}`} onClick={action}>
    {icon ? <i className={icon} /> : ""}
    <span className="text-center">{title}</span>
    {isOrderOpened && (
      <div className="opened-order">
        {isOrderOpened == "oz" ? "Otvorená objednávka" : "Klientská objednávka"}
      </div>
    )}
    {isSpecialCart && (
      <div className="opened-order">
        Špecialný košík aktívny
      </div>
    )}
  </button>
);

CustomerAction.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  action: PropTypes.func.isRequired,
  isOrderOpened: PropTypes.bool,
  active: PropTypes.string
};

export default CustomerAction;



// WEBPACK FOOTER //
// ./src/routes/CustomerList/components/CustomerAction.js